import Keyb from "keyb"
import Pointer from "poin"

import Stage from "@frog/source/models/Stage.js"
import Selection from "@frog/source/models/Selection.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Director from "@frog/source/juice/Director.js"
import Geometry from "@frog/source/utility/Geometry.js"
import App from "@frog/source/models/App.js"
import InkDialogue from "@frog/source/utility/InkDialogue.js"

export default class CombatEncounter {
    static load(proto) {
        const encounter = new CombatEncounter()
        encounter.type = "combat"
        encounter.player = proto.encounter.player || {"affiliation": "good"}
        encounter.slug = proto.encounter.slug
        encounter.images = proto.encounter.images
        encounter.audio = proto.encounter.audio
        encounter.hasPreparePhase = proto.encounter.hasPreparePhase
        if(encounter.audio != undefined) {
            Audiomix.trigger(encounter.audio)
        }

        encounter.encounters = proto.encounter.encounters

        // encounter.events = proto.encounter.events

        // TODO: Let the proto.encounter reference pre-existing encounters as well,
        // not just pre-existing encounter.stages.

        encounter.selection = new Selection({"encounter": encounter})

        encounter.stage = Stage.load({
            "stage": proto.encounter.stage,
            "player": proto.player,
            "chapterParty": proto.chapterParty,
            "hasPreparePhase": encounter.hasPreparePhase,
        })
        // encounter.calculateActions(encounter.stage, true) // for some reason stage.hasCalculatedActions persists across reloads, pass true to always force on initial load

        // let that = encounter
        // for(let key in that) {
        //     this[key] = that[key]
        // }

        encounter.previousStages = []


        encounter.sequence = {
            "steps": []
                // .concat(Stage.getEventSteps(encounter.stage, "turn:0:start"))
                // .concat(Stage.getEventSteps(encounter.stage, "turn:every:start"))
                // .concat(Stage.getEventSteps(encounter.stage, "turn:every-even:start"))
        }
        if(encounter.sequence.steps != undefined
        && encounter.sequence.steps.length > 0) {
            encounter.stage = encounter.sequence.steps[encounter.sequence.steps.length - 1].omegastage
        }

        if(encounter.hasPreparePhase == true) {
            encounter.startPreparePhase()
        } else {
            encounter.startPlayPhase()
        }

        return encounter
    }
    startPreparePhase() {
        this.phase = "prepare"
    }
    startPlayPhase({dialogue} = {}) {
        this.phase = "play"

        Stage.calculateActions(this.stage)

        this.addEvents([]
            .concat(Stage.getEventSteps(this.stage, "encounter:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:0:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every-even:start")))

        // this.endPlayerTurn()
        // Stage.calculateNextTurn(this.stage)
        // this.performNextTurn(this.stage) // BOMBER
    }
    addSteps(steps) {
        this.sequence = {steps}
    }
    addEvents(events) {
        this.addSteps(Stage.processEventSteps(this.stage, events))
    }
    update(delta) {
        this.selection.update(delta)

        if(Keyb.wasJustPressed("Z")) {
            this.undoAction()
        }
    }
    setStage(stage) {
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            this.stage = this.previousStages.pop()

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.frog != undefined
            && window.frog.test != undefined
            && window.frog.test.snapshot != undefined) {
                window.frog.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            // if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
            //     this.selection.reset()
            // }
            this.selection.reset()

            this.sequence = undefined
        }
    }
    performAction(action) {
        const steps = action.steps
        Director.add(steps)

        // // Auto-finishing
        // if(Stage.hasFinishedTurn(this.player.affiliation, action.omegastage)) {
        //     // getNonPlayerSteps
        // }

        if(window.frog != undefined
        && window.frog.test != undefined
        && window.frog.test.snapshot != undefined) {
            window.frog.test.snapshot.protoactions.push({
                "unitKey": action.performerKey,
                "position": Geometry.copy(action.position),
                "actionKey": action.key,
            })
        }

        const omegastage = steps[steps.length-1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)

        return omegastage
    }
    endPlayerTurn(stage) {
        if(Director.isPerforming == true) {
            return
        }
        stage = stage || this.stage

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()

        // And now.. perform the next turn!!

        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }

        const steps = stage.nextTurn.steps
        Director.add(steps)

        const omegastage = steps[steps.length-1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)
        this.clearPreviousStages()
    }
}
